/* DEPARTMENTS */
export const GET_LOST_ORDERS = "GET_LOST_ORDERS"
export const GET_LOST_ORDERS_SUCCESS = "GET_LOST_ORDERS_SUCCESS"
export const GET_LOST_ORDERS_FAIL = "GET_LOST_ORDERS_FAIL"

export const ADD_LOST_ORDER = "ADD_LOST_ORDER"
export const ADD_LOST_ORDER_SUCCESS = "ADD_LOST_ORDER_SUCCESS"
export const ADD_LOST_ORDER_FAIL = "ADD_LOST_ORDER_FAIL"

export const UPDATE_LOST_ORDER = "UPDATE_LOST_ORDER"
export const UPDATE_LOST_ORDER_SUCCESS = "UPDATE_LOST_ORDER_SUCCESS"
export const UPDATE_LOST_ORDER_FAIL = "UPDATE_LOST_ORDER_FAIL"

export const DELETE_LOST_ORDER = "DELETE_LOST_ORDER"
export const DELETE_LOST_ORDER_SUCCESS = "DELETE_LOST_ORDER_SUCCESS"
export const DELETE_LOST_ORDER_FAIL = "DELETE_LOST_ORDER_FAIL"

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"